import { createSolidStreamingMarkdown } from "@storytell/markdown";
import { createEffect } from "solid-js";

export const createMarkdownStreamerFromDeltas = (deltas: () => string[]) => {
  const markdownStreamer = createSolidStreamingMarkdown(deltas().join(""));
  const initialLength = deltas().length;

  createEffect((lastLength: number | undefined) => {
    const normalizedLastLength = lastLength ?? initialLength;
    const currentLength = deltas().length;
    if (currentLength > normalizedLastLength) {
      markdownStreamer.append(deltas().slice(normalizedLastLength, currentLength).join(""));
    }
    return currentLength;
  });

  return markdownStreamer;
};
